// extracted by mini-css-extract-plugin
export default {"pitstopGif":"CTABanner_pitstopGif__vUVPF"};